export const useStepId = (id: string) => {
  return `[data-step-id="${id}"]`;
}
